import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react'
import {
  Card,
  ContentSection,
  SectionHeading,
  Toggle,
} from '@vwfs-bronson/bronson-react'
import { useTranslation } from 'react-i18next'
import { Formik, FormikProps } from 'formik'
import { DeliveryAddressFieldset } from './fieldset'
import getInitialValues from './initial-values'
import { getValidationSchema } from './validation-schema'

interface DeliveryAddressProps {
  getValues: (values: any) => void,
  required?: boolean,
}

const DeliveryAddress = forwardRef((props: DeliveryAddressProps, ref) => {
  const { t } = useTranslation()
  const { getValues, required = false } = props
  const formState = useRef({}) as any
  let setFormFieldValue;

  useImperativeHandle(ref, () => ({
    isSelected: () => formState.current.formProps?.values?.customerData?.deliveryAddressActive,
    submit: () => {
      return formState.current.formProps?.submitForm()
    },
    getData: () => formState.current.formProps.values,
    validate: () => formState.current.formProps.isValid,
  }))

  useEffect(() => {
    if (required) {
      setFormFieldValue?.('customerData.deliveryAddressActive', required)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [required])

  return (
    <>
    <Formik
      enableReinitialize
      initialValues={getInitialValues()}
      validationSchema={getValidationSchema()}
      onSubmit={() => {}}
    >
      {(formProps: FormikProps<any>) => {
        getValues(formProps?.values)
        formState.current = { formProps }
        const { setFieldValue, values } = formProps
        setFormFieldValue = setFieldValue
        return (
          <ContentSection pageWrap className="u-pt-small u-pb-small">
            <ContentSection.ComponentWrapper>
              <Card
                id="deliveryAddressAccordion"
                title={<SectionHeading level={3} className='u-mt-small'>{t('form:deliveryAddress:title')}</SectionHeading>}
                subtitle={values?.customerData?.deliveryAddressActive
                    ? <span className='u-text-base'>{t('form:deliveryAddress:subtitle:expanded')}</span>
                    : <span className='u-text-base'>{t('form:deliveryAddress:subtitle:closed')}</span>
                }
                expandable
                contentShort={
                  <Toggle
                    onChange={(e: any) => {
                      setFieldValue('customerData.deliveryAddressActive', e?.target?.checked)
                    }}
                    checked={values?.customerData?.deliveryAddressActive}
                    disabled={required}
                  />
                }
              >
                {values?.customerData?.deliveryAddressActive && (
                  <DeliveryAddressFieldset />
                )}
              </Card>
            </ContentSection.ComponentWrapper>
          </ContentSection>
        )
      }}
    </Formik>
    </>
  )
})

export default DeliveryAddress
